import React from 'react'

const AttendanceManagement = () => {
  return (
    <div>AttendanceManagement</div>
  )
}

export default AttendanceManagement